"use client";

import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";

const api = apiInstance()

export const submitPropertyConsignment = async (data = {}) => {
  return api.post(`/${PUBLIC_V1}/module/portal/sale-rent-form`, data)
}
